import React, { useState } from 'react'
import Modal from 'utils/Modal'
import logo from 'assets/images/logo.png'
import { useData } from 'context/DataContext'
import Alert from 'utils/Alert'
import { db, ref, push, remove, update } from 'config/Firebase'
import { useEffect } from 'react'

let valuesObject = {
  name: '',
  link: '',
  order_number: '',
  // category: '',
  beckend: '',
  portfolio: '',
  platform: '',
  description: '',
  status: '',
  footer_branding: '',
  notes: '',
}

const platforms = ['Fiverr', 'Upwork', 'Others']

const ProjectForm = () => {
  const [modal, setModal] = useState(false)
  const [inputValues, setInputValues] = useState(valuesObject)
  const [projectCategorySelected, setProjectCategorySelected] = useState([])
  const [alert, setAlert] = useState({ open: false, msg: '', type: '' })
  const [submitting, setSubmitting] = useState(false)
  const [projectId, setProjectId] = useState('')
  const [projectsLink, setProjectsLink] = useState([])
  const [filterState, setFilterState] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [filterProjectData, setFilterProjectData] = useState([])
  const [toggleCategoryList, settoggleCategoryList] = useState(false)
  const [portfolioCheck, setPortfolioCheck] = useState('')
  const { categoriesData, data } = useData()

  useEffect(() => {
    setFilterProjectData(data)
  }, [data])

  const handleChange = (e) => {
    // console.log(e.target.value)
    setInputValues({ ...inputValues, [e.target.name]: e.target.value })
  }
  //   console.log(data)
  const handleAddData = (e) => {
    e.preventDefault()
    setSubmitting(true)
    if (projectCategorySelected.length > 0) {
      if (!projectId.length > 0) {
        console.log('new project')
        push(ref(db, 'projects/'), {
          inputValues,
          categories: projectCategorySelected,
        })
          .then(() => {
            setModal(false)
            setSubmitting(false)
            setInputValues(valuesObject)
            setProjectCategorySelected([])
            setProjectId('')
            setAlert({
              open: true,
              msg: 'Data Save successfully.',
              type: 'success',
            })
          })
          .catch((err) => {
            console.log(err)
            setModal(false)
            setSubmitting(false)
            setAlert({
              open: true,
              msg: 'Something went wrong!',
              type: 'error',
            })
          })
      } else if (projectId.length > 0) {
        console.log('update project')
        update(ref(db, `projects/${projectId}`), {
          inputValues,
          categories: projectCategorySelected,
        })
          .then(() => {
            setModal(false)
            setSubmitting(false)
            setInputValues(valuesObject)
            setProjectId('')
            setProjectCategorySelected([])
            setAlert({
              open: true,
              msg: 'Data Updated successfully.',
              type: 'success',
            })
          })
          .catch((err) => {
            console.log(err)
            setModal(false)
            setSubmitting(false)
            setAlert({
              open: true,
              msg: 'Something went wrong!',
              type: 'error',
            })
          })
      }
    } else {
      setAlert({
        open: true,
        msg: 'Please select atleast one category',
        type: 'error',
      })
    }
    // console.log(inputValues)
  }

  // delete project from database
  const handleDelete = (e) => {
    remove(ref(db, `projects/${e}`))
      .then((res) => {
        setAlert({
          open: true,
          msg: 'Data Deleted successfully.',
          type: 'success',
        })
      })
      .catch((err) => {
        setAlert({ open: true, msg: 'Something went wrong!', type: 'error' })
      })
  }

  // edit project function
  const handleEdit = (event) => {
    console.log(event)
    setModal(true)
    setProjectCategorySelected(event.categories)
    setInputValues(event.inputValues)
    setProjectId(event.id)
  }

  // check and uncheck of category checkbox
  const handleCheck = (e) => {
    if (e.target.checked) {
      setProjectsLink([...projectsLink, e.target.value])
    } else {
      let filter = projectsLink.filter((val) => val !== e.target.value)
      setProjectsLink(filter)
    }
  }

  // copy selected urls
  const copyText = async (id) => {
    let setFormat = projectsLink.join('\n')
    navigator.clipboard
      .writeText(setFormat)
      .then(() => {
        setAlert({
          open: true,
          msg: 'Text Copied successfully.',
          type: 'success',
        })
      })
      .catch(() => {
        setAlert({
          open: true,
          msg: 'Text not Copied successfully.',
          type: 'success',
        })
      })
  }

  //  filters by category
  const handleChangeFilter = (e) => {
    if (e.target.checked) {
      setFilterState([...filterState, e.target.value])
    } else {
      let filter = filterState.filter((val) => val !== e.target.value)
      setFilterState(filter)
    }
  }

  //  select categories for project and add it in firebase
  const handleSetCategory = (e) => {
    if (e.target.checked) {
      setProjectCategorySelected([...projectCategorySelected, e.target.value])
    } else {
      let filter = projectCategorySelected.filter(
        (val) => val !== e.target.value,
      )
      setProjectCategorySelected(filter)
    }
  }
  const handleUnselectCategory = (e) => {
    let filterdSelectedCategory = projectCategorySelected.filter(
      (val) => val !== e,
    )
    setProjectCategorySelected(filterdSelectedCategory)
  }
  //  show and hide categories checkbox of modal form
  const handleShowCategoryList = () => {
    settoggleCategoryList(!toggleCategoryList)
  }

  // main search box - matches against project name AND order number,
  // so there's a single search field instead of two separate ones
  const handleSearch = (e) => {
    setSearchValue(e.target.value)
  }

  // portfolio Check radio function
  const handleRadio = (e) => {
    setPortfolioCheck(e.target.value)
  }

  // true if a project matches the single search box, checked against
  // both the project name and the order number (case-insensitive substring)
  const matchesSearch = (val) => {
    if (!searchValue) return true
    const query = searchValue.toLowerCase()
    const nameMatch = val.inputValues.name.toLowerCase().includes(query)
    const orderNumberMatch = (val.inputValues.order_number || '')
      .toLowerCase()
      .includes(query)
    return nameMatch || orderNumberMatch
  }

  // wraps the portion of `text` that matches the current search box value
  // in a <mark>, so a hit on name or order number is visible at a glance
  const highlightMatch = (text, query) => {
    const str = text == null ? '' : String(text)
    if (!query) return str
    const lowerStr = str.toLowerCase()
    const lowerQuery = query.toLowerCase()
    let start = 0
    let idx = lowerStr.indexOf(lowerQuery, start)
    if (idx === -1) return str
    const parts = []
    while (idx !== -1) {
      parts.push(str.slice(start, idx))
      parts.push(
        <mark key={idx} className="search-highlight">
          {str.slice(idx, idx + query.length)}
        </mark>,
      )
      start = idx + query.length
      idx = lowerStr.indexOf(lowerQuery, start)
    }
    parts.push(str.slice(start))
    return parts
  }

  useEffect(() => {
    let filterData = data.filter((val) => {
      // if categroy filter selected and porfolio checked
      if (filterState.length > 0 && portfolioCheck.length > 0) {
        return (
          filterState.every((el) => val.categories.includes(el)) &&
          matchesSearch(val) &&
          val.inputValues.portfolio === portfolioCheck
        )
      }
      // filter with category selected and not selec portfolio check
      else if (filterState.length > 0) {
        return (
          filterState.every((el) => val.categories.includes(el)) &&
          matchesSearch(val)
        )
      }
      // filter with portfolio Check that true / false/all and category not selected
      else if (portfolioCheck.length > 0) {
        return val.inputValues.portfolio === portfolioCheck && matchesSearch(val)
      }
      // if categroy filter not selected only search with input field
      else {
        return matchesSearch(val)
      }
    })
    // console.log(filterData)
    if (filterState.length > 0 || searchValue || portfolioCheck.length > 0) {
      setFilterProjectData(filterData)
    } else {
      setFilterProjectData(data)
    }
  }, [filterState, searchValue, portfolioCheck, data])

  // const handleRange = (e) => {
  //   let val = e.target.value
  //   let commission = Number(val * 0.03)
  //   console.log(e.target.value, commission)
  // }

  // console.log(data)
  return (
    <div>
      {/* <input
        type="range"
        name="range"
        id="range"
        min={400000}
        step={25000}
        max={5000000}
        onChange={handleRange}
      /> */}
      {/*================ Modal ===================*/}
      <Modal open={modal}>
        <div className="cs_modal_wrapper">
          <div
            className="cs_modal_backdrop"
            onClick={() => setModal(false)}
          ></div>
          <div className="cs_modal">
            <header className="cs_modal_header cs_row align-items-center justify-content-between">
              <div>
                <img src={logo} alt="Smash Code" />
              </div>
              <button onClick={() => setModal(false)} className="cs_icon_btn">
                &times;
              </button>
            </header>
            <div className="cs_modal_body">
              <h3>Fiverr/Upwork :</h3>
              <br />
              <form onSubmit={handleAddData}>
                <div>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    onChange={handleChange}
                    placeholder="Website Name"
                    required
                    value={inputValues.name}
                  />
                  <br /> <br />
                  <textarea
                    name="description"
                    id="description"
                    value={inputValues.description}
                    onChange={handleChange}
                    cols="30"
                    rows="3"
                    placeholder='Project Description'
                  ></textarea>
                  <br /> <br />
                  <input
                    type="url"
                    name="link"
                    id="link"
                    onChange={handleChange}
                    placeholder="Website Link"
                    required
                    value={inputValues.link}
                  />
                  <br /> <br />
                  <input
                    type="text"
                    id="order_number"
                    name="order_number"
                    onChange={handleChange}
                    placeholder="Order Number"
                    value={inputValues.order_number}
                  />
                  <br />
                  <br />
                  <p>Category</p>
                  <div className="checkList">
                    <div className="ctCheckList cs_row align-items-center justify-content-between">
                      <div className="ctData cs_row align-items-center flex-wrap">
                        {projectCategorySelected.length > 0
                          ? projectCategorySelected.map((val) => (
                              <p key={val}>
                                {val}{' '}
                                <span
                                  onClick={() => handleUnselectCategory(val)}
                                >
                                  x
                                </span>
                              </p>
                            ))
                          : null}
                      </div>
                      <button
                        className="exIconBtn"
                        onClick={handleShowCategoryList}
                        type="button"
                      >
                        &#9660;
                      </button>
                    </div>
                    {toggleCategoryList ? (
                      <div className="ctList">
                        {categoriesData.length &&
                          categoriesData.map((val) => {
                            let isTrue
                            let isSelected = projectCategorySelected.find(
                              (data) => {
                                if (data === val.category) {
                                  isTrue = true
                                  return isTrue
                                } else {
                                  isTrue = false
                                  return isTrue
                                }
                              },
                            )
                            console.log(isTrue)
                            return (
                              <div
                                className="categories cs_row align-items-center "
                                key={val.id}
                              >
                                <input
                                  type="checkbox"
                                  name="category"
                                  id={val.category}
                                  checked={isTrue ? true : false}
                                  value={val.category}
                                  onChange={handleSetCategory}
                                />
                                <p>{val.category}</p>
                              </div>
                            )
                          })}
                      </div>
                    ) : null}
                  </div>
                  {/* <br />  */}
                  <br />
                  <select
                    name="status"
                    id="status"
                    onChange={handleChange}
                    value={inputValues.status}
                  >
                    <option value="">Status</option>
                    <option value="Pending">Pending</option>
                    <option value="Published">Published</option>
                    
                  </select>
                  <br />
                  <br />
                  <select
                    name="beckend"
                    required
                    id="beckend"
                    onChange={handleChange}
                    value={inputValues.beckend}
                  >
                    <option value="full stack">Beckend</option>
                    <option value="true">true</option>
                    <option value="false">false</option>
                  </select>
                  <br />
                  <br />
                  <select
                    name="platform"
                    required
                    id="platform"
                    onChange={handleChange}
                    value={inputValues.platform}
                  >
                    <option value="full stack">Platform</option>
                    <option value="Fiverr">Fiverr</option>
                    <option value="Upwork">Upwork</option>
                    <option value="others">others</option>
                  </select>
                  <br />
                  <br />
                  <select
                    name="portfolio"
                    id="portfolio"
                    onChange={handleChange}
                    value={inputValues.portfolio}
                    required
                  >
                    <option value="">Portfolio</option>
                    <option value="true">true</option>
                    <option value="false">false</option>
                  </select>
                  <br />
                  <br />
                  <select
                    name="footer_branding"
                    id="footer_branding"
                    onChange={handleChange}
                    value={inputValues.footer_branding}
                  >
                    <option value="">Footer Branding</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
              
             
                  <br />
                  <br />
                  <textarea
                    name="notes"
                    id="notes"
                    value={inputValues.notes}
                    onChange={handleChange}
                    cols="30"
                    rows="3"
                    placeholder="Notes"
                  ></textarea>
                </div>
                <footer className="cs_modal_footer cs_row align-items-center justify-content-between">
                  <span></span>
                  <button className="cs_btn" disabled={submitting}>
                    Save &#10004;
                  </button>
                </footer>
              </form>
            </div>
          </div>
          {/* {submitting && <Loader type="imgloader_fixed" />} */}
        </div>
      </Modal>
      <br />
      <div className="cs_row px-2 justify-content-between flex-wrap">
        <h1 className="text_center">Fiverr/Upwork :</h1>
        <div className="cs_row align-items-center">
          {/* {!viewMode && ( */}
          <button
            className="cs_btn"
            style={{ marginLeft: '10px' }}
            onClick={() => {
              setProjectId('')
              setModal(true)
              setProjectCategorySelected([])
              setInputValues(valuesObject)
              // console.log(projectId)
            }}
          >
            Add New +
          </button>
          {/* )} */}
        </div>
      </div>
      <br /> <br />
      <div className="projectList">
        {/* category filters   */}
        <div className='cs_row align-items-start '>

        <div style={{ width: '30%' }} className="fList">
          Filters: <br />
          <ul className="">
            {categoriesData.length > 0
              ? categoriesData.map((val) => (
                  <li
                    className="cs_row px-2 py-1  justify-content-between align-items-center"
                    key={val.id}
                  >
                    <span>{val.category}</span>
                    <input
                      type="checkbox"
                      value={val.category}
                      onChange={handleChangeFilter}
                    />
                  </li>
                ))
              : null}
          </ul>
        </div>
        {/* other filters  */}
        <div style={{ width: '30%',marginLeft:'20px' }} className="fList">
          <p>Portfolio :</p>
          <div>
            <label
              htmlFor="true"
              className="cs_row px-2   justify-content-between align-items-center"
            >
              <p>True</p>
              <input
                type="radio"
                name="portfolio"
                id="true"
                value="true"
                onChange={handleRadio}
              />
            </label>
            <label
              htmlFor="false"
              className="cs_row px-2   justify-content-between align-items-center"
            >
              <p>False</p>
              <input
                type="radio"
                name="portfolio"
                id="false"
                value="false"
                onChange={handleRadio}
              />
            </label>
            <label
              htmlFor="all"
              className="cs_row px-2   justify-content-between align-items-center"
            >
              <p>All</p>
              <input
                type="radio"
                name="portfolio"
                id="all"
                value=""
                onChange={handleRadio}
              />
            </label>
          </div>
        </div>
        </div>

        <div className="searchBar cs_row flex-wrap">
          <div style={{ width: '50%' }}>
            <input
              type="text"
              value={searchValue}
              placeholder="Search by name or order number"
              onChange={handleSearch}
            />
          </div>
          <br />
        </div>

        <div className="cs_row align-items-center">
          <p className="numProj">
            Number Of Projects : {filterProjectData.length}
          </p>
          {projectsLink.length > 0 ? (
            <>
              <button style={{ marginLeft: '15px' }} onClick={() => copyText()}>
                Copy Urls
              </button>
            </>
          ) : null}
        </div>
        <br />
        <div className="tbSection">
          {filterProjectData.length > 0 ? (
            <table id="customers">
              <thead>
                <tr>
                  <th>S.no</th>
                  <th></th>
                  <th>Link</th>
                  <th>Name</th>
                  {/* <th>Description</th> */}
                  <th>Category</th>
                  {/* <th>Platform</th> */}
                  <th>Beckend</th>
                  {/* <th>Portfolio</th> */}
                  <th>Status</th>
                  <th>Order No</th>
                  <th>Footer Branding</th>
                  <th>URL Branding</th>
                  <th>Notes</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filterProjectData.map((val, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>
                      <input
                        type="checkbox"
                        name="id"
                        id="id"
                        value={val.inputValues.link}
                        onChange={handleCheck}
                      />
                    </td>
                    <td id="links">
                      <a
                        href={val.inputValues.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {val.inputValues.link}
                      </a>{' '}
                    </td>
                    <td>{highlightMatch(val.inputValues.name, searchValue)}</td>
                    {/* <td>{val.inputValues?.description}</td> */}
                    <td>
                      {val.categories.map((res) => (
                        <span key={res}>{' ' + res + ' '}</span>
                      ))}
                    </td>
                    {/* <td>
                        {val.inputValues.platform
                          ? val.inputValues.platform
                          : null}
                      </td> */}
                    <td>{val.inputValues.beckend}</td>
                    {/* <td>{val.inputValues.portfolio}</td> */}
                    <td>{val.inputValues?.status}</td>
                    <td>
                      {highlightMatch(
                        val.inputValues?.order_number,
                        searchValue,
                      )}
                    </td>
                    <td>{val.inputValues?.footer_branding}</td>
                    <td>{val?.inputValues?.link.includes("smashcode") ? "Yes":"No"}</td>
                    <td>{val.inputValues?.notes}</td>
                    <td className="cs_row .flex-wrap align-items-center justify-content-center">
                      <button
                        onClick={() => handleDelete(val.id)}
                        className="my-2"
                      >
                        &#10060;
                      </button>{' '}
                      <button
                        onClick={() => handleEdit(val)}
                        className="my-2"
                      >
                        &#9998;
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="emptyState">
              {searchValue ? (
                <p>No projects found matching "{searchValue}".</p>
              ) : (
                <p>No projects match the current filters.</p>
              )}
            </div>
          )}
        </div>
      </div>
      <Alert data={alert} setAlert={setAlert} />
    </div>
  )
}

export default ProjectForm